import { CollapseActions } from "./actions";

export const collapseReducer = (state: Set<string>, action: CollapseActions) => {
  if (action.type === "COLLAPSE_HIDE") {
    state.delete(action.groupId);

    return new Set<string>(state);
  }

  if (action.type === "COLLAPSE_SHOW") {
    state.add(action.groupId);

    return new Set<string>(state);
  }

  return state;
};
